import React from "react";

export default function Warn() {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 0.875C3.11758 0.875 0.375 3.61758 0.375 7C0.375 10.3824 3.11758 13.125 6.5 13.125C9.88242 13.125 12.625 10.3824 12.625 7C12.625 3.61758 9.88242 0.875 6.5 0.875ZM6.0625 4.04688C6.0625 3.98672 6.11172 3.9375 6.17188 3.9375H6.82812C6.88828 3.9375 6.9375 3.98672 6.9375 4.04688V7.76562C6.9375 7.82578 6.88828 7.875 6.82812 7.875H6.17188C6.11172 7.875 6.0625 7.82578 6.0625 7.76562V4.04688ZM6.5 10.0625C6.32827 10.059 6.16476 9.98831 6.04455 9.86562C5.92434 9.74294 5.85701 9.57801 5.85701 9.40625C5.85701 9.23449 5.92434 9.06956 6.04455 8.94688C6.16476 8.82419 6.32827 8.75351 6.5 8.75C6.67173 8.75351 6.83524 8.82419 6.95545 8.94688C7.07566 9.06956 7.14299 9.23449 7.14299 9.40625C7.14299 9.57801 7.07566 9.74294 6.95545 9.86562C6.83524 9.98831 6.67173 10.059 6.5 10.0625Z"
        fill="#EF465B"
      />
    </svg>
  );
}
